import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected", null )

const getLocalAreaCards = (body) => http.post("/property_local_area", body);


export default {
    getLocalAreaCards
}